import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as SiteOfflineStyles from "../styles/siteOffline";

//ACTIONS
import * as GS_generalSettingsActions from "../../../../store/actions/globalSettings/GS_generalSettings";

function SiteOffline() {
    const dispatch = useDispatch();
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    const textRef = useRef(null);

    function handleKeyPress(event) {
        if (event.key === "Enter") {
            const { value } = event.target;
            handleAccessCode(value);
        }
    }

    function handleAccessCode(code) {
        const data = { accessCode: code };
        Axios.post("/adminPods/overview/checkSiteAccessCode", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    console.log(data.valid);
                    if (data.valid) {
                        dispatch(GS_generalSettingsActions.UpdateSiteOffline(false));
                    } else {
                        textRef.current.value = "";
                    }
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={SiteOfflineStyles.body}>
            <h1>
                <strong>Site Offline</strong>
            </h1>
            <br />
            {GS_generalSettings.offlineMessage == "" ? (
                <div>
                    <h2>This site is down for maintenance</h2>
                </div>
            ) : (
                <div>
                    <h2>{GS_generalSettings.offlineMessage}</h2>
                </div>
            )}
            <br />
            <h3>Access Code</h3>
            <br />
            <Form.Control ref={textRef} type="text" placeholder={"Enter Code"} style={SiteOfflineStyles.textBox} onKeyPress={handleKeyPress} />
            Press &apos;Enter&apos; to confirm
        </div>
    );
}

export default SiteOffline;
